import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=67e98c02&scoped=true&"
import script from "./EmailDetail.vue?vue&type=script&lang=js&"
export * from "./EmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmailDetail.vue?vue&type=style&index=0&id=67e98c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e98c02",
  null
  
)

export default component.exports